module.exports = __webpack_public_path__ + "static/foryou-whole-support.00a22b78.jpg";